import { IDropdownProps } from 'legacy/lut/library/dropdown'
import React from 'react'

import { IRichTextEditorProps } from 'core-components/library/richTextEditor'
import { VisualAudienceExtended } from 'core/components/shared/ui/VisualAudienceExtended'
import { OnboardingDropdown, OnboardingRichTextEditor } from 'onboarding/components/ui/theme'

import styles from '../PartnerShipNA.module.scss'

import { IPartnerShipNA, IPartnerShipNaCrud } from './types'

interface IProps {
  onChange: (field: string) => (value: string) => void
  crud: IPartnerShipNaCrud
  item: IPartnerShipNA
  writeAudience: IObjectAny
  disabled?: boolean
}

export const OtherDetailsNa = ({ onChange, crud, item, writeAudience, disabled }: IProps) => {
  return (
    <div className={styles.root__otherDetails}>
      <div className={styles.text__title}>To be filled in by Contacts Team</div>
      <div className={styles.root}>
        <VisualAudienceExtended<IDropdownProps>
          component={OnboardingDropdown}
          write={writeAudience}
          margin={'md'}
          label="Partner Recruited"
          source={crud.PartnerRecruited}
          value={item.PartnerRecruited || ''}
          caption="label"
          onChange={onChange('PartnerRecruited')}
          disabled={disabled}
        />
        <VisualAudienceExtended<IDropdownProps>
          component={OnboardingDropdown}
          write={writeAudience}
          margin={'md'}
          label="Is this a Residentail Address"
          source={crud.IsResidentailAddress}
          value={item.IsResidentailAddress || ''}
          caption="label"
          onChange={onChange('IsResidentailAddress')}
          disabled={disabled}
        />
        <VisualAudienceExtended<IDropdownProps>
          component={OnboardingDropdown}
          write={writeAudience}
          margin={'md'}
          label="Agent Partner"
          source={crud.AgentPartner}
          value={item.AgentPartner || ''}
          caption="label"
          onChange={onChange('AgentPartner')}
          disabled={disabled}
        />
      </div>
      <div className={styles.root__type}>
        <div className={styles.rte}>
          <div className={styles.rteLabel}>Exception Granted</div>
          <VisualAudienceExtended<IRichTextEditorProps>
            component={OnboardingRichTextEditor}
            write={writeAudience}
            toolbarVisible={false}
            value={item.ExceptionGranted}
            onChange={onChange('ExceptionGranted')}
            disabled={disabled}
          />
        </div>
        <div className={styles.rte}>
          <div className={styles.rteLabel}>Comments</div>

          <VisualAudienceExtended<IRichTextEditorProps>
            component={OnboardingRichTextEditor}
            write={writeAudience}
            toolbarVisible={false}
            value={item.Comments}
            onChange={onChange('Comments')}
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  )
}
